// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"491":"45bad8c99a868e9b6d8f","763":"4e2f6ef66d4b2529efa3"}[chunkId] + ".js";
};